import columns from '../../../../react-table/helpers/columns';

export default (data) => {
  const {
    NumberColumn,
    DateColumn,
  } = columns(data);

  return [
    {
      Header: 'Past BOH information',
      columns: [
        new DateColumn('Date', 'date'),
        new NumberColumn('BOH', 'balanceOnHand'),
        new NumberColumn('BOH Day DIFF', 'bohDayDiff'),
      ],
    },
  ];
};
